import type { ReturnedCheckout } from '../lib/returned-checkout'

/**
 * What the gift page shows, from the server's link status and what the page
 * knows of the checkout it came back to.
 *
 * The page may claim a gift is paid only when a server read says so. Browser
 * query flags never enter this decision. While the checkout's outcome is
 * unread, unreadable or still clearing, the link is not offered for paying
 * again: the payment may have gone through.
 */
export type GiftServerStatus = 'open' | 'paid' | 'expired' | 'invalid'

export type GiftView =
  | 'paid'
  | 'processing'
  | 'checking'
  | 'check_error'
  | 'open'
  | 'expired'
  | 'invalid'

export function giftView(
  server: GiftServerStatus,
  checkout: ReturnedCheckout,
): GiftView {
  if (server === 'expired') return 'expired'
  if (server === 'invalid') return 'invalid'
  if (server === 'paid' || checkout === 'paid') return 'paid'
  if (checkout === 'processing') return 'processing'
  if (checkout === 'checking') return 'checking'
  if (checkout === 'error') return 'check_error'
  return 'open'
}
